module.exports = __webpack_public_path__ + "static/tv-bottom-386d5c0313751b65a19be1f8ac06b45a.png";